import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Work from "@/components/Work";
import Footer from "@/components/Footer";

const WorkPage = () => {
  return (
    <div className="min-h-screen overflow-hidden">
      <Helmet>
        <title>Work | Priya Pareek</title>
        <meta
          name="description"
          content="Explore Priya Pareek's portfolio of visual art, design, and creative projects, including paintings, digital art, and illustrations."
        />
      </Helmet>
      <Navbar />
      <Work />
      <Footer />
    </div>
  );
};

export default WorkPage;